<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/news/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>活動訊息</h1>
        </div>
      </header>
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">活動列表</h2>
            <div class="public-news-list">
              <router-link
                v-for="activity in activities"
                :key="activity.id"
                :to="`/activity-list/${activity.id}`"
                class="public-news-list-item"
              >
                <div class="public-news-list-item-left-part">
                  <div class="mb-2"></div>
                  <div>
                    <h4>{{ activity.title }}</h4>
                  </div>
                </div>
                <div class="public-news-list-item-right-part">
                  <i class="fas fa-chevron-right text-success"></i>
                </div>
              </router-link>
            </div>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import db from "../../api/db";
export default {
  name: "PublicActivityListScreen",
  components: {
    PublicLayout,
  },
  data() {
    return {
      activities: [],
    };
  },
  methods: {},
  mounted() {
    const vm = this;
    db.collection("activities")
      .where("isPublished", "==", true)
      .orderBy("createdAt", "desc")
      .get()
      .then((docs) => {
        const activities = [];
        docs.forEach((doc) => {
          const activity = doc.data();
          activity.id = doc.id;
          activities.push(activity);
        });
        vm.activities = activities;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>